module.exports = __webpack_public_path__ + "c8db5730e5b605481c6ee4e3df6fa1e2.pdf";